import { useCallback } from 'react';

export const useFormatAmount = (locale?: string) => {
    const formatCurrencyAmount = useCallback(
        (amount: number, region?: string, fractionDigits?: number) => {
            let currencyLocale = 'no-NO';
            switch (locale) {
                case 'sv':
                    currencyLocale = 'sv-SE';
                    break;
                case 'da':
                    currencyLocale = 'da-DK';
                    break;
                case 'en':
                    currencyLocale = 'en-GB';
                    break;
                default:
                    break;
            }

            let currency = 'NOK';
            switch (region) {
                case 'Sverige':
                    currency = 'SEK';
                    break;
                case 'Danmark':
                    currency = 'DKK';
                    break;
                case 'Europa':
                    currency = 'GBP';
                    break;
                default:
                    break;
            }

            return new Intl.NumberFormat(currencyLocale, {
                style: 'currency',
                currency: currency,
                minimumFractionDigits: fractionDigits ?? 0,
            }).format(amount);
        },
        [locale],
    );

    return { formatCurrencyAmount };
};
